import { combineReducers } from 'redux';
import axios from 'axios';
import _ from 'lodash';

import * as Urls from 'src/constants/EndpointUrls';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { MAX_POLLING_INTERVAL, INITIAL_POLLING_INTERVAL } from 'src/constants/Generals';
import { listReducer, itemReducer } from 'src/reducers/common';
import { getExtras, setExtras } from 'src/reducers/common/listReducer';
import { setGlobalErrors } from 'src/reducers/global';
import { concatParamsToUrl, redirectTo } from 'src/utils/Http';

export const REDUCER_NAME = 'notificationOfBaseAmountRevisionAsync';
export const getPdfJob = (state, revisionYear) => _.get(_.get(getExtras(REDUCER_NAME, state), 'pdfJob'), revisionYear);
export const getIsFetchCompleted = state => _.get(getExtras(REDUCER_NAME, state), 'isFetchCompleted');

export const fetchPdfJobStatus = (interval, revisionYear) => async dispatch => {
  try {
    const params = { revision_year: revisionYear };
    dispatch(setExtras(REDUCER_NAME, { isFetchCompleted: false }));
    const response = await axios.get(
      concatParamsToUrl(Urls.REPORT_NOTIFICATION_OF_BASE_AMOUNT_REVISIONS_PDF_FETCH_STATUS, params)
    );
    const pdfJob = response.data.payload.pdfJob;
    dispatch(
      setExtras(REDUCER_NAME, {
        pdfJob: { [revisionYear]: Object.assign(response.data.payload.pdfJob) },
        isFetchCompleted: true
      })
    );

    if (_.includes(['waiting', 'running'], _.get(pdfJob, 'status'))) {
      const nextInterval = MAX_POLLING_INTERVAL > interval ? interval * 2 : interval;
      setTimeout(() => {
        dispatch(fetchPdfJobStatus(nextInterval, revisionYear));
      }, nextInterval);
    }
  } catch (e) {
    if (!_.isUndefined(e.response)) {
      const { status } = e.response;
      if (status !== 404) {
        dispatch(setGlobalErrors('PDF作成処理が正常に完了しませんでした。時間をおいて再度実行してください。'));
      }
    } else {
      dispatch(setGlobalErrors('不明なエラーが発生しました。'));
    }
    dispatch(setExtras(REDUCER_NAME, { isFetchCompleted: true }));
  }
};

export const setPdfJob = (revisionYear, hideModal, isRecreate = false) => async dispatch => {
  try {
    let response = null;
    if (isRecreate) {
      response = await axios.post(
        concatParamsToUrl(Urls.RECREATE_NOTIFICATION_OF_BASE_AMOUNT_REVISIONS_PDF, {
          revision_year: revisionYear
        })
      );
    } else {
      const params = { revisionYear };
      response = await axios.post(Urls.CREATE_NOTIFICATION_OF_BASE_AMOUNT_REVISIONS_PDF, params);
    }
    dispatch(setExtras(REDUCER_NAME, { pdfJob: { [revisionYear]: Object.assign(response.data.payload.pdfJob) } }));

    setTimeout(() => {
      dispatch(fetchPdfJobStatus(INITIAL_POLLING_INTERVAL, revisionYear));
    }, INITIAL_POLLING_INTERVAL);
    hideModal();
  } catch (e) {
    dispatch(setGlobalErrors('エラーが発生しました。ページをリロードしてください。'));
  }
};

export const fetchZipPdf = revisionYear => async dispatch => {
  try {
    const url = concatParamsToUrl(Urls.REPORT_NOTIFICATION_OF_BASE_AMOUNT_REVISIONS_PDF_FETCH_ZIP, {
      revision_year: revisionYear
    });
    redirectTo(url);
  } catch (err) {
    dispatch(setGlobalErrors('エラーが発生しました。ページをリロードしてください。'));
  }
};

export const fetchPdf = revisionYear => async dispatch => {
  try {
    const url = concatParamsToUrl(Urls.REPORT_NOTIFICATION_OF_BASE_AMOUNT_REVISIONS_PDF_FETCH_PDF, {
      revision_year: revisionYear
    });
    const w = window.open(url, '', 'toolbar=0,menubar=0,location=0');
    if (_.isFunction(w.addEventListener)) {
      w.addEventListener('load', () => {
        w.print();
      });
    }
  } catch (err) {
    dispatch(setGlobalErrors('エラーが発生しました。ページをリロードしてください。'));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
